import { Brain, Headphones, Shield, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";


export const features = [
    {
        icon: Brain,
        title: 'extensionPage.features.ai.title',
        description: 'extensionPage.features.ai.description',
        color: 'from-purple-500 to-blue-500'
    },
    {
        icon: Headphones,
        title: 'extensionPage.features.voice.title',
        description: 'extensionPage.features.voice.description',
        color: 'from-pink-500 to-red-500'
    },
    {
        icon: Zap,
        title: 'extensionPage.features.instant.title',
        description: 'extensionPage.features.instant.description',
        color: 'from-yellow-500 to-orange-500'
    },
    {
        icon: Shield,
        title: 'extensionPage.features.privacy.title',
        description: 'extensionPage.features.privacy.description',
        color: 'from-green-500 to-teal-500'
    }
];

export const stats = [
    { number: "100K+", label: 'extensionPage.stats.users' },
    { number: "4.8/5", label: 'extensionPage.stats.rating' },
    { number: "50+", label: 'extensionPage.stats.languages' },
    { number: "99.9%", label: 'extensionPage.stats.uptime' }
];

export const testimonials = [
    {
        name: "Sarah M.",
        role: 'extensionPage.testimonials.sarah.role',
        content: 'extensionPage.testimonials.sarah.content',
        rating: 5
    },
    {
        name: "David L.",
        role: 'extensionPage.testimonials.david.role',
        content: 'extensionPage.testimonials.david.content',
        rating: 5
    },
    {
        name: "Marie K.",
        role: 'extensionPage.testimonials.marie.role',
        content: 'extensionPage.testimonials.marie.content',
        rating: 5
    }
];
